export default "__VITE_ASSET__BvqUVksa__"